import React from "react";

export const LeftAlignIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0833 16.5833H20.25V14.75H11.0833V16.5833ZM3.75 12L7.41667 15.6667V8.33333L3.75 12ZM3.75 20.25H20.25V18.4167H3.75V20.25ZM3.75 3.75V5.58333H20.25V3.75H3.75ZM11.0833 9.25H20.25V7.41667H11.0833V9.25ZM11.0833 12.9167H20.25V11.0833H11.0833V12.9167Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
